<h3 class="schema__advantage-item-title schema__advantage-item-title-dark">
  {{ 'main.schemas.expertiseExchange' | translate }}
</h3>

<div class="schema__card schema__paragraph-regular schema__paragraph-dark">
  {{ 'main.schemas.exchangeKnowledge' | translate }}
</div>
